<template>
	<div
		:id="`participant-video-${participant.sid}`"
		class="tw-relative tw-bg-white tw-w-full tw-h-full bg-color max-vh-vw"
		:class="[full_viewport ? 'bg-color-host' : 'bg-color-participant']"
	>
		<camera-video-player
			ref="camera"
			:camera_is_muted="camera_is_muted"
			:full_viewport="full_viewport"
			:microphone_is_muted="microphone_is_muted"
			:multiple_presenters="multiple_presenters"
			:participant="participant"
			:show_screenshare="show_screenshare"
			:speaking="speaking"
			:volume="live_room.volume"
		/>
	</div>
</template>

<script>
import CameraVideoPlayer from "./CameraVideoPlayer.vue";
import {ParticipantEvent, RoomEvent} from 'livekit-client';

export default {
	name: 'ParticipantVideo',
	components: {
		'camera-video-player': CameraVideoPlayer,
	},
	data(){
		return {
			speaking: false,
			camera_is_muted: true,
			microphone_is_muted: true,
			user,
		}
	},
	props: {
		full_viewport: {
			required: true,
			type: Boolean
		},
		is_local: {
			required: false,
			type: Boolean,
			default: false,
		},
		live_room: {
			required: true,
			type: Object,
		},
		multiple_presenters: {
			default: false,
			type: Boolean,
		},
		participant: {
			required: true,
			type: Object,
		},
		show_screenshare: {
			type: Boolean,
			default: false,
		},
	},
	async mounted(){
        if(this.is_local){
			this.participant.on(ParticipantEvent.LocalTrackPublished, this.handleLocalTrackPublished);
			this.participant.on(ParticipantEvent.LocalTrackUnpublished, this.handleLocalTrackUnpublished);
		} else {
            this.live_room.tracks_subscribed.forEach(track => {
                if(!track.is_attached && track.remote_participant_id === this.participant.sid){
                    this.setTrackMuted(track.source, track.isMuted)
                    this.attachTrack(track);
                }
            })
			this.participant.on(ParticipantEvent.TrackSubscribed, this.handleTrackSubscribed);
			this.participant.on(ParticipantEvent.TrackUnsubscribed, this.handleTrackUnsubscribed);
		}

		this.participant.on(ParticipantEvent.TrackMuted, (t) => this.handleTrackMuted(t, true));
		this.participant.on(ParticipantEvent.TrackUnmuted, (t) => this.handleTrackMuted(t, false));
		this.participant.on(ParticipantEvent.IsSpeakingChanged, this.handleSpeakingChanged);
	},
	methods: {
		handleLocalTrackPublished(localTrackPublication){
			this.setTrackMuted(localTrackPublication.source, localTrackPublication.track.isMuted);
			this.attachTrack(localTrackPublication.track);
		},
		handleLocalTrackUnpublished(localTrackPublication){
			this.setTrackMuted(localTrackPublication.source, true);
			if(localTrackPublication.track){
				localTrackPublication.track.detach();
			}
		},
		handleTrackSubscribed(remoteTrack) {
            this.setTrackMuted(remoteTrack.source, remoteTrack.isMuted)
			this.attachTrack(remoteTrack);
		},
		handleTrackUnsubscribed(remoteTrack, remoteTrackPublication) {
			this.setTrackMuted(remoteTrackPublication.source, true);
			remoteTrack.detach();
			const index = this.live_room.tracks_subscribed.findIndex(t => t.sid === remoteTrack.sid);
			if(index !== -1 ) {
				this.live_room.tracks_subscribed.splice(index);
			}
		},
		handleTrackMuted(trackPublication, is_muted) {
			this.setTrackMuted(trackPublication.source, is_muted);
			const index =  this.live_room.tracks_subscribed.findIndex(track => trackPublication.track.sid === track.sid);
			this.live_room.tracks_subscribed[index] = trackPublication.track;
		},
		handleSpeakingChanged(){
			this.speaking = !this.speaking;
		},
		setTrackMuted(source, is_muted) {
			switch (source) {
				case 'microphone':
					if (this.is_local) {
						this.live_room.local_microphone_is_muted = is_muted;
					}
					this.microphone_is_muted = is_muted;
					break;
				case 'camera':
					if (this.is_local) {
						this.live_room.local_camera_is_muted = is_muted;
					}
					this.camera_is_muted = is_muted;
					break;
				default:
					break;
			}
		},
		async attachTrack(track) {
			const camera_el = this.$refs.camera.$refs.video;
            const audio_el = this.$refs.camera.$refs.audio;
            const subscribed_track = this.live_room.tracks_subscribed.find(t => t.sid === track.sid);

            switch (track.source) {
				case 'microphone':
					if(!this.is_local){
						await track.attach(audio_el);
                        subscribed_track.is_attached = true;
					}
					break;
				case 'camera':
					await track.attach(camera_el);
                    subscribed_track.is_attached = true;
					break;
				default:
					break;
			}
		},
	},
}
</script>

<style scoped>
.bg-color-host {
	background: #37474F;
}
.bg-color-participant {
	background: #2F2F2F;
}
.max-vh-vw {
	max-width: 100vw;
	max-height: 100vh;
}
</style>
